<div fxLayout="row" fxLayoutAlign="none center" fxLayoutGap="1rem" class="permission-list-container">
    <ng-container *ngIf="currentPermissions">
        <ng-container *ngIf="singleMode">
            <button *ngIf="!readOnly && !!availablePermissions?.length" mat-button color="accent"
                    class="add-perm-button"
                    [matMenuTriggerFor]="permissionsMenu"
                    (click)="onClickAddPermissionMenu($event)">
                {{'Add'|i18n}}
                <mat-menu #permissionsMenu="matMenu">
                    <ng-container *ngFor="let permission of availablePermissions">
                        <button mat-menu-item (click)="onClickAddPermission(permission)">
                            <app-icon [name]="permission|permissionIcon"></app-icon>&nbsp;&nbsp;
                            {{permission|permissionName}}
                        </button>
                    </ng-container>
                </mat-menu>
            </button>
        </ng-container>
        <ng-container *ngIf="patternMode">
            <button *ngIf="!readOnly && !!availablePatterns?.length" mat-button color="accent"
                    class="add-perm-button"
                    [matMenuTriggerFor]="patternsMenu"
                    (click)="onClickAddPermissionMenu($event)">
                {{'Set'|i18n}}
                <mat-menu #patternsMenu="matMenu">
                    <ng-container *ngFor="let pattern of availablePatterns">
                        <button mat-menu-item (click)="onClickSetPattern(pattern)">
                            <ng-container *ngIf="pattern.icon">
                                <app-icon [name]="pattern.icon"></app-icon>&nbsp;&nbsp;
                            </ng-container>
                            {{pattern.name}}
                        </button>
                    </ng-container>
                </mat-menu>
            </button>
        </ng-container>
        <mat-chip-list *ngIf="currentPermissions.length">
            <mat-chip *ngFor="let permission of currentPermissions"
                      [selectable]="false" [removable]="!readOnly && singleMode"
                      [title]="permission|permissionDescription|i18n"
                      (removed)="onClickRemovePermission(permission)" color="primary"
                      selected class="chip">
                <app-icon [name]="permission|permissionIcon"></app-icon>&nbsp;&nbsp;
                {{permission|permissionName}}
                <fa-icon *ngIf="!readOnly && singleMode" matChipRemove [icon]="['far', 'times-circle']"
                         [title]="'Remove permission'|i18n">\
                </fa-icon>
            </mat-chip>
        </mat-chip-list>
        <div *ngIf="!currentPermissions.length">
            <span>{{'No permissions'|i18n}}</span>
        </div>
    </ng-container>
</div>
